import { render, staticRenderFns } from "./UpdateContactInfo.vue?vue&type=template&id=3f661932&"
import script from "./UpdateContactInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports